export default "__VITE_ASSET__ZVvf_fXf__"